import {Set, Map, type RecordOf} from 'immutable';
import type {PageRecordType} from '@packages/systems/core/records/PageRecord';
import type {DesignerStores} from '@packages/systems/designer/flux';

export {
  pageSavedRemotely,
  pageFolderSaved,
  pageBranched,
  pageDeletedSuccess,
} from './actions';
export {
  transformMultiplayerPageFolderSavedRemotely,
  transformMultiplayerPageSavedRemotely,
  transformMultiplayerPageBranchedRemotely,
  transformMultiplayerPageDeletedRemotely,
  transformMultiplayerCollectionDeletedRemotely,
  transformMultiplayerBranchMergedRemotely,
  transformMultiplayerBranchDeletedRemotely,
  withLegacyActionStructure,
} from './transforms';

export {
  outOfSyncBranchActions,
  branchStage,
  branchIconColor,
  BRANCH_MODES,
  FETCH_BRANCH_TASK_MAX_TRIES,
  FETCH_BRANCH_TASK_POLLING_INTERVAL,
  BRANCH_MERGE_UPDATE_ALLOWED_ERRORS,
  BRANCH_LIBRARY_INSTALL_IN_PROGRESS_MESSAGE,
  BRANCH_LIBRARY_INSTALL_IN_PROGRESS_ERROR,
  BRANCH_PUBLISH_IN_PROGRESS_MESSAGE,
  BRANCH_PUBLISH_IN_PROGRESS_ERROR,
  BRANCH_SYNC_PENDING_MESSAGE,
  BRANCH_GATEWAY_ERROR,
} from '@packages/systems/designer/branch/PageBranchConstants';
export type {BranchModeType} from '@packages/systems/designer/branch/PageBranchConstants';

type PageManagerUIStateShape = {
  expandedFolders: Set<string>;
  initialFocus: string | null;
  automaticRedirect: boolean;
  selectedItem: PageRecordType;
  changedSettings: Set<string>;
  location: string | null;
  translationsLoading: Map<string, boolean>;
};
export type PageManagerUIState = RecordOf<PageManagerUIStateShape>;

export const getPageStore = (state: DesignerStores) => state.PageStore;
export const getPageManagerUIStore = (state: DesignerStores) =>
  state.PageManagerUIStore;
export {
  selectCurrentPageId,
  selectPageState,
  selectPageManagerUIState,
  selectReviews,
  selectCurrentPageItemId,
  selectBranchingInProgress,
  selectPageNameMap,
  selectPages,
  selectCurrentPageType,
  selectIsDynamicPage,
} from './selectors';
export type {CurrentPageType} from './selectors';
